const SPOTIFY_CLIENT_ID = import.meta.env.VITE_SPOTIFY_CLIENT_ID;
const APP_DOMAIN = import.meta.env.VITE_APP_DOMAIN || 'tracktoss.cc';
const SPOTIFY_REDIRECT_URI = `https://${APP_DOMAIN}/auth/callback`;

console.log('Spotify Auth Configuration:', {
  APP_DOMAIN,
  SPOTIFY_REDIRECT_URI,
  VITE_APP_DOMAIN: import.meta.env.VITE_APP_DOMAIN,
});

const SPOTIFY_SCOPES = [
  'streaming', // Required for playback
  'user-read-playback-state', // Required for getting playback state
  'user-modify-playback-state', // Required for controlling playback
  'user-read-currently-playing', // Required for getting current track
  'playlist-read-private', // Required for playlist access
].join(' ');

export const spotifyAuth = {
  getLoginUrl: (playlistId?: string) => {
    const params = new URLSearchParams({
      client_id: SPOTIFY_CLIENT_ID,
      response_type: 'token',
      redirect_uri: SPOTIFY_REDIRECT_URI,
      scope: SPOTIFY_SCOPES,
      show_dialog: 'true',
      state: playlistId || '', // Store playlist ID in state parameter
    });

    return `https://accounts.spotify.com/authorize?${params.toString()}`;
  },

  handleCallback: () => {
    const hash = window.location.hash.substring(1);
    const params = new URLSearchParams(hash);
    const accessToken = params.get('access_token');
    const expiresIn = params.get('expires_in');
    const state = params.get('state'); // Get playlist ID from state

    if (accessToken && expiresIn) {
      // Store the token and its expiration
      localStorage.setItem('spotify_access_token', accessToken);
      localStorage.setItem(
        'spotify_token_expires_at',
        (Date.now() + parseInt(expiresIn) * 1000).toString(),
      );

      // Add playlist to authorized list if state (playlistId) exists
      if (state) {
        const authorizedPlaylists = JSON.parse(
          localStorage.getItem('spotify_authorized_playlists') || '[]',
        );
        if (!authorizedPlaylists.includes(state)) {
          authorizedPlaylists.push(state);
          localStorage.setItem('spotify_authorized_playlists', JSON.stringify(authorizedPlaylists));
        }
      }

      // Remove the hash from the URL
      window.history.replaceState({}, document.title, window.location.pathname);

      // Redirect back to playlist if state exists
      if (state) {
        window.location.href = `/playlist/${state}`;
        return null; // Return null since we're redirecting
      }

      return accessToken;
    }

    return null;
  },

  getAccessToken: () => {
    const token = localStorage.getItem('spotify_access_token');
    const expiresAt = localStorage.getItem('spotify_token_expires_at');

    if (!token || !expiresAt) {
      return null;
    }

    // Check if token is expired
    if (Date.now() > parseInt(expiresAt)) {
      localStorage.removeItem('spotify_access_token');
      localStorage.removeItem('spotify_token_expires_at');
      return null;
    }

    return token;
  },

  isPlaylistAuthorized: (playlistId: string): boolean => {
    const authorizedPlaylists = JSON.parse(
      localStorage.getItem('spotify_authorized_playlists') || '[]',
    );
    return authorizedPlaylists.includes(playlistId);
  },

  logout: () => {
    localStorage.removeItem('spotify_access_token');
    localStorage.removeItem('spotify_token_expires_at');
    localStorage.removeItem('spotify_authorized_playlists');
  },
};
